import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { CircularProgress, Typography, List, ListItem, ListItemText, Box } from '@mui/material';

const API_URL = process.env.REACT_APP_API_URL;

const Notifications = ({ userId }) => {

  useEffect(() => {
    window.scrollTo(0, 0);  // Scroll to top when this page is loaded
  }, []);
 
  
  const [loading, setLoading] = useState(true);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await axios.get(`${API_URL}/user/notifications/`, {
          params: { user_id: userId },
        });

        setNotifications(response.data);
      } catch (error) {
        console.error('Error fetching notifications:', error);
      } finally {
        setLoading(false);
      }
    };

    if (userId) {
      fetchNotifications();
    }
  }, [userId]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 10 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (notifications.length === 0) {
    return <Typography variant="h6" sx={{ textAlign: 'center', mt: 5 }}>No notifications found</Typography>;
  }

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h5" component="h1" sx={{ fontWeight: 'bold' }}>
        Notifications
      </Typography>
      <List>
        {notifications.map((notification) => (
          <ListItem key={notification.id}>
            <ListItemText
              primary={notification.comments || 'No comments'}
              secondary={`Created at: ${new Date(notification.created_at).toLocaleString()}`}
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default Notifications;
